/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListSupportTicketsQueryResponse, ListSupportTicketsQueryParams, ListSupportTickets400, ListSupportTickets401, ListSupportTickets403, ListSupportTickets404, ListSupportTickets409, ListSupportTickets500 } from "../../types/supportController/ListSupportTickets.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listSupportTickets } from "../../client/supportController/listSupportTickets.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listSupportTicketsQueryKey = (params?: ListSupportTicketsQueryParams) => [{ url: '/api/support/tickets/' }, ...(params ? [params] : [])] as const

export type ListSupportTicketsQueryKey = ReturnType<typeof listSupportTicketsQueryKey>

export function listSupportTicketsQueryOptions(params?: ListSupportTicketsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listSupportTicketsQueryKey(params)
        return queryOptions<ListSupportTicketsQueryResponse, ResponseErrorConfig<ListSupportTickets400 | ListSupportTickets401 | ListSupportTickets403 | ListSupportTickets404 | ListSupportTickets409 | ListSupportTickets500>, ListSupportTicketsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return listSupportTickets(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List support tickets
 * {@link /api/support/tickets/}
 */
export function useListSupportTickets<TData = ListSupportTicketsQueryResponse, TQueryData = ListSupportTicketsQueryResponse, TQueryKey extends QueryKey = ListSupportTicketsQueryKey>(params?: ListSupportTicketsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListSupportTicketsQueryResponse, ResponseErrorConfig<ListSupportTickets400 | ListSupportTickets401 | ListSupportTickets403 | ListSupportTickets404 | ListSupportTickets409 | ListSupportTickets500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listSupportTicketsQueryKey(params)
         

         const query = useQuery({
          ...listSupportTicketsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListSupportTickets400 | ListSupportTickets401 | ListSupportTickets403 | ListSupportTickets404 | ListSupportTickets409 | ListSupportTickets500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}